import * as React from "react";
import {cs} from "../../../../../../../react/chain-services";
import "./step-1-select-list.scss";
import {UseState} from "../../../../../../../react/use-state";
import {Header} from "../../common/header/header";
import {cx} from "emotion";
import {ImportNamingSection} from "./import-naming-section/import-naming-section";
import {SelectListSection} from "./select-list-section/select-list-section";

export const Step1SelectList = ({entityId, next}) => cs(
    ["selectListSection", (_, next) => SelectListSection({entityId, next})],
    ["defaultNames", (_, next) => UseState({
        initValue: {
            defaultName: "",
            defaultName2: "",
            replaceName: false,
        },
        next
    })],
    ["importNamingSection", ({defaultNames}, next) => ImportNamingSection({defaultNames, next})],
    ({selectListSection, importNamingSection, defaultNames}) => next({
        render: ({onCancel, cancelLabel, onNext}) => cs(
            ["showErrors", (_, next) => UseState({next})],
            ({showErrors}) => (
                <div className="step-1-select-list-8o1">
                    {Header({
                        icon: require("../../../../mailing-icons/listtype-crm.png"),
                        title: "Import CRM List",
                        subTitle: "Build a list targeting prospects on a specific CRM.",
                    })}

                    <div className="content">

                        {selectListSection.render({showErrors: showErrors.value})}

                        {importNamingSection.render()}

                    </div>

                    <div className="footer">
                        <button {...{
                            className: "cancel",
                            onClick: onCancel,
                            "xd-qa-type": "button",
                            "xd-qa-name": "CRM List " + cancelLabel,
                        }}>
                            {cancelLabel}
                        </button>

                        {cs(
                            ["submitting", (_, next) => UseState({next})],
                            ({submitting}) => (
                                <button {...{
                                    className: cx("next", {
                                        disabled: !selectListSection.valid && !importNamingSection.valid,
                                    }),
                                    disabled: submitting.value,
                                    onClick: async () => {
                                        if (!selectListSection.valid) {
                                            if (!showErrors.value) {
                                                showErrors.onChange(true);
                                            }
                                            selectListSection.highlightErrors();
                                        }else if (!importNamingSection.valid) {
                                            if (!showErrors.value) {
                                                showErrors.onChange(true);
                                            }
                                            importNamingSection.highlightErrors();
                                        } else {
                                            if(hj && typeof hj === 'function')
                                            {
                                                hj('event', `CRM_list_create_click_event`);
                                            }
                                            submitting.onChange(true);
                                            onNext({selectedCRMLists: selectListSection.getSelecteds(), ...defaultNames.value});
                                            submitting.onChange(false);
                                        }
                                    },
                                    "xd-qa-type": "button",
                                    "xd-qa-name": "CRM List Begin Import",
                                }}>
                                    Begin Import
                                </button>
                            ),
                        )}
                    </div>
                </div>
            ),
        )
    }),
);
